// extracted by mini-css-extract-plugin
export default {"container":"StateCards_container__ZHMTD","stateCard":"StateCards_stateCard__qw1C4"};